import {
  PageResponse,
  Response,
  PageData,
  IntegrationOrderSearchParams,
  IntegrationOrderVo,
  IntegrationDeleteOrderDo,
  IntegrationOrderDetailVo,
  IntegrationUpdateAssociatedCubeOrderDo,
} from "@/types";
import { APIRequest } from "@/utils/api";

const IntegrationOrderAPI = new APIRequest({
  baseURL: "/api/wms/v2/integration/orders",
});

export async function queryOrders(
  params: IntegrationOrderSearchParams
): Promise<PageData<IntegrationOrderVo>> {
  return IntegrationOrderAPI.get<PageResponse<IntegrationOrderVo>>({
    url: "",
    params,
  }).then((res) => res.data);
}

export async function deleteOrder(
  params: IntegrationDeleteOrderDo
): Promise<boolean> {
  return IntegrationOrderAPI.delete<Response<boolean>>({
    url: `/${params.orderId}`,
    data: params,
  }).then((res) => res.data);
}

export async function detailIntegrationOrder(
  id: string
): Promise<IntegrationOrderDetailVo> {
  return IntegrationOrderAPI.get<Response<IntegrationOrderDetailVo>>({
    url: `/${id}`,
  }).then((res) => res.data);
}

export async function updateOrderAssociatedCubeId(
  id: number,
  data: IntegrationUpdateAssociatedCubeOrderDo
): Promise<boolean> {
  return IntegrationOrderAPI.patch<Response<boolean>>({
    url: `/${id}/cube`,
    data,
  }).then((res) => res.data);
}

export async function getIntegrationOrderTMSProductUsage(
  orderId: string
): Promise<Record<string, number>> {
  return IntegrationOrderAPI.get<Response<Record<string, number>>>({
    url: `/${orderId}/tms/usage`,
  }).then((res) => res.data);
}
